<ion-app [class.impersonating]="impersonation.isImpersonating()" [class.with-dev]="isDev">
  @if (isDev) {
    <div class="dev-banner">DEV</div>
  }
  <ion-router-outlet [swipeGesture]="swipe"></ion-router-outlet>
  @if (impersonation.isImpersonating()) {
    <div class="impersonation-banner">
      <span>
        Viendo como {{ impersonation.impersonatedUser()?.name }} {{ impersonation.impersonatedUser()?.lastname }}
      </span>
      <button type="button" (click)="exitImpersonation()">Salir</button>
    </div>
  }
</ion-app>
